import { get, getObj2, post, postInvalidate } from './fetch'
import { UpdateVendorList } from './user'

export type ApiGatewayStatus = {
  serviceName: 'ocr_invoice_v2' | 'ocr_general' | 'ocr_order_form'
  status: 'created' | 'none' | 'failed'
}

export interface SystemSettings {
  midMin: number
  highMin: number
  confidence: boolean
}

export interface SystemSettingsResponse {
  systemSettings: SystemSettings
  vendorListStatus: UpdateVendorList
}

export function getSystemSettings(cache = true) {
  return get('system-settings', { cache }) as Promise<SystemSettingsResponse>
}

type ApiGatewayStatusResponse = { result: ApiGatewayStatus[] }

const APIGWS_CACHE_ID = 'apigwcacheid'
export async function getApiGatewayStatus(): Promise<ApiGatewayStatus[]> {
  const params = { serviceName: 'ocr_invoice_v2,ocr_general,ocr_order_form' }
  const data = await getObj2<ApiGatewayStatusResponse>('apigw', {
    params,
    cache: true,
    id: APIGWS_CACHE_ID,
  })
  return data.result
}

export async function setupApiGateway(
  useInvoice: boolean,
  useOrderForm: boolean,
) {
  const serviceName = ['ocr_general'] as ApiGatewayStatus['serviceName'][]
  if (useInvoice) {
    serviceName.unshift('ocr_invoice_v2')
  }
  if (useOrderForm) {
    serviceName.unshift('ocr_order_form')
  }
  const payload = {
    serviceName,
  }
  const result = await postInvalidate('apigw', APIGWS_CACHE_ID, payload)
  return result.data.result
}

export function updateSystemSettings(payload) {
  return post('system-settings', payload)
}
